export default {
  background: '#FFFFFF',
  primary: '#1DA57A',
  error: '#E8495C',
  discount: '#E8495C',

  space: [
    0, 4, 7, 8, 14, 16, 21, 32, 64, 128, 256
  ],
  breakpoints: [
    '768px', '992px', '1200px'
  ]
};